import React from 'react'
import { Typography, TypographyProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from 'hooks/useMediaQuery'

interface IPageHeaderDescriptionProps extends Omit<TypographyProps, 'variant'> {
  children: React.ReactNode
}

const PageHeaderDescription: React.FunctionComponent<IPageHeaderDescriptionProps> = (props: IPageHeaderDescriptionProps) => {
  const { children, ...restProps } = props
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(t => t.breakpoints.down('sm'))

  if (isSmallScreen) {
    return null
  }

  return (
    <div style={{ margin: theme.spacing(1, 0, 0, 0) }}>
      <Typography variant="body2" {...restProps}>
        {children}
      </Typography>
    </div>
  )
}

export default PageHeaderDescription
